import { getNestedKeyValue } from 'MODULES/universal-filters/utils/nestedKeysUtils';
import { toUrlOperator } from 'MODULES/universal-filters/utils/operators';
import {
  isNumberFilterValues,
  isStringUniversalExpression,
  UniversalFilter,
} from 'MODULES/universal-filters/utils/types';
import { FilterTypeEnum } from 'SRC/fetch/api/observability';
import { isNullish } from 'UTILS/isNullish';
import { majorToMinor } from 'UTILS/money';

export const ActionEnum = {
  APPEND: 'append',
  DELETE: 'delete',
} as const;

export const modifyUniversalParams = (
  filters: Map<string, UniversalFilter>,
  newParams: URLSearchParams,
  action: (typeof ActionEnum)[keyof typeof ActionEnum],
) => {
  for (const [filterKey, entry] of filters.entries()) {
    if (isNumberFilterValues(entry.values)) {
      for (const [operator, value] of entry.values) {
        const param = `${filterKey}.${toUrlOperator(operator)}`;

        if (action === ActionEnum.APPEND && !isNullish(value)) {
          const filterKeyValue = getNestedKeyValue(filterKey);

          const parsedValue =
            entry.type === FilterTypeEnum.CURRENCY && filterKeyValue
              ? majorToMinor(value, filterKeyValue)
              : value;

          newParams.append(param, `${parsedValue}`);
        } else {
          newParams.delete(param);
        }
      }
    } else {
      const operator = isStringUniversalExpression(entry) && entry.operator;
      if (!operator) {
        continue;
      }

      const param = `${filterKey}.${toUrlOperator(operator)}`;

      if (action === ActionEnum.DELETE) {
        newParams.delete(param);
        continue;
      }

      if (Array.isArray(entry.values) && entry.values.length > 0) {
        for (const value of entry.values) {
          newParams.append(param, value);
        }
      } else if (
        isNullish(entry.values) ||
        (Array.isArray(entry.values) && entry.values.length === 0)
      ) {
        newParams.append(param, '');
      } else {
        newParams.append(param, `${entry.values.join(',')}`);
      }
    }
  }
};
